import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  employeePolicyList: [],
  totalEmployeePolicyList: 0,
  employeePolicy: {},
  employeePersonalPolicy: {
    personal_policy: {
      Statements: [],
    },
  },
}

export const mutations = {
  SET_EMPLOYEE_POLICY_LIST(state, employeePolicyList) {
    state.employeePolicyList = employeePolicyList
  },
  SET_TOTAL_EMPLOYEE_POLICY_LIST(state, totalEmployeePolicyList) {
    state.totalEmployeePolicyList = totalEmployeePolicyList
  },
  SET_EMPLOYEE_POLICY(state, employeePolicy) {
    state.employeePolicy = employeePolicy
  },
  SET_EMPLOYEE_PERSONAL_POLICY(state, employeePersonalPolicy) {
    state.employeePersonalPolicy = employeePersonalPolicy
  },
}

export const actions = {
  fetchEmployeePolicyList({ commit }, payload) {
    return ApiService.fetchEmployeePolicyList(payload)
      .then((res) => {
        const employeePolicyList = res.data.data

        commit('SET_EMPLOYEE_POLICY_LIST', employeePolicyList)
        commit('SET_TOTAL_EMPLOYEE_POLICY_LIST', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  getEmployeePolicy({ commit, getters, state }, payload) {
    if (state.employeePolicy.employee_uuid === payload.employee_uuid) {
      return state.employeePolicy
    }

    const employeePolicy = getters.getEmployeePolicyByUuid(
      payload.employee_uuid
    )

    if (employeePolicy) {
      commit('SET_EMPLOYEE_POLICY', employeePolicy)
    } else {
      return ApiService.fetchEmployeePolicy(payload)
        .then((res) => {
          const employeePolicy = res.data
          commit('SET_EMPLOYEE_POLICY', employeePolicy)
        })
        .catch((error) => {
          throw error
        })
    }
  },
  fetchEmployeePersonalPolicy({ commit }, payload) {
    return ApiService.fetchEmployeePersonalPolicy(payload)
      .then((response) => {
        commit('SET_EMPLOYEE_PERSONAL_POLICY', response.data)
      })
      .catch((error) => {
        throw error
      })
  },
  updateEmployeePolicyRoles({ commit }, payload) {
    return ApiService.updateEmployeePolicyRoles(payload)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  updateEmployeePersonalPolicy({ commit }, payload) {
    return ApiService.updateEmployeePersonalPolicy(payload)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeePersonalPolicy({ commit }, payload) {
    return ApiService.deleteEmployeePersonalPolicy(payload)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeePolicy({ commit }, payload) {
    return ApiService.fetchEmployeePolicy(payload)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getEmployeePolicyByUuid: (state) => (employee_uuid) => {
    return state.employeePolicyList.find(
      (item) => item.employee_uuid === employee_uuid
    )
  },
}
